import React, { useState } from 'react';
import { JobDetails } from '../../../../entities/JobDetails';
import { SelectOption } from '../../../../components/Select';
import { useInfiniteJobs } from '../../../../queries/v1/applicant_tracking/useInfiniteJobs';
import TransparentSelect from '../../../../components/Select/variants/transparent';
import useOptions from '../../../../hooks/useOptions';
import { Job } from '../../../../entities/v1/Job';
import { SingleValue } from 'react-select';
import { generatePath, matchPath, useNavigate } from 'react-router';

interface PageTitleSelectPropTypes {
  initialJob: JobDetails;
}

const jobToOption = (job: Job) => ({
  label: job.name,
  value: job.id.toString(),
});

function PageTitleSelect({ initialJob }: PageTitleSelectPropTypes) {
  const navigate = useNavigate();
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [textInput, setTextInput] = useState<string | undefined>(undefined);
  const { data: jobListPages, fetchNextPage } = useInfiniteJobs(
    hasBeenFocused,
    textInput,
  );

  const options = useOptions(
    jobListPages?.pages.flatMap((page) => page.jobs) ?? [],
    jobToOption,
    initialJob,
  );

  const handleChangeJob = (newValue: SingleValue<SelectOption>) => {
    const routes = [
      '/jobs/:id/overview',
      '/jobs/:id/pipeline',
      '/jobs/:id/paid_job_boards',
    ];

    const route = routes.find((route) =>
      matchPath(route, window.location.pathname),
    );

    const path = route
      ? generatePath(route, { id: newValue?.value })
      : `/jobs/${newValue?.value}`;

    navigate(path);
  };

  return (
    <TransparentSelect
      options={options}
      defaultValue={{ label: initialJob.name, value: initialJob.id.toString() }}
      onFocus={() => {
        setHasBeenFocused(true);
      }}
      onMenuScrollToBottom={() => fetchNextPage()}
      onInputChange={(inputValue) => setTextInput(inputValue)}
      onChange={handleChangeJob}
    />
  );
}

export default PageTitleSelect;
